import * as React from "react";

import { cn } from "@/shared/lib/cn";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "circular" | "text";
}

function Skeleton({ className, variant = "default", ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse bg-muted",
        {
          default: "rounded-md",
          circular: "rounded-full",
          text: "rounded h-4 w-3/4",
        }[variant],
        className
      )}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
